// src/features/encounter/encounterSlice.ts
//       // ❷ 환자 정보 수정 API 호출
import { createSlice, createAsyncThunk, PayloadAction } from "@reduxjs/toolkit"
import { PharmaItemSerializer as PharmaSimpleSerializer } from "@/types/pharma"
import { fetchPharmaSimple } from "@core/api/pharmaSimpleApi"
// import { fetchPharma } from "@core/api/pharmaApi"

interface PharmaPayload {
  pharmaSimples: PharmaSimpleSerializer[] | null
  loading: boolean
  error: string | null
}

const initialState: PharmaPayload = {
  pharmaSimples: null,
  loading: false,
  error: null,
}

const pharmaSimpleSlice = createSlice({
  name: "pharmaItems",
  initialState,
  reducers: {
    clearPharmaSimple(state) {
      state.pharmaSimples = null
    },
    setLoading(state, action: PayloadAction<boolean>) {
      state.loading = action.payload
    },
    setError(state, action: PayloadAction<string | null>) {
      state.error = action.payload
    },
  },
  extraReducers: (builder) => {
    builder
      // fetchPatients 관련 처리
      .addCase(fetchPharmaSimple.pending, (state) => {
        state.loading = true
        state.error = null
      })
      .addCase(fetchPharmaSimple.fulfilled, (state, action) => {
        state.loading = false
        state.pharmaSimples = action.payload
        // console.debug("수가 목록", state.sugas)
      })
      .addCase(fetchPharmaSimple.rejected, (state, action) => {
        state.loading = false
        state.pharmaSimples = null
        state.error =
          (action.payload as string) || action.error.message || "오류 "
      })
  },
})

export const { clearPharmaSimple, setLoading, setError } =
  pharmaSimpleSlice.actions

export default pharmaSimpleSlice.reducer
